import request from '@/libs/request'

export function articleList (data) {
  return request({
    url: `newsCate/list`,
    method: 'get',
    params: data
  })
}

// 公告详情
export function CateInfo (data) {
  return request({
    url: `newsCate/info/`+data,
    method: 'get',
    // params: data
  })
}

// 添加公告
export function eidtCate (data) {
  return request({
    url: `newsCate/edit`,
    method: 'post',
    data: data
  })
}

// 删除公告
export function delNew (id) {
  let data = { article_id: id }
  return request({
    url: `newsCate/delete`,
    method: 'post',
    data: data
  })
}

export function changeSort (params) {
  return request({
    url: `newsCate/changeSort`,
    method: 'get',
    params
  })
}
// 启用禁用
export function changeStatus (id) {
  return request({
    url: `newsCate/changeStatus/${id}`,
    method: 'post'
  })
}
export function getIndexCate (params) {
  return request({
    url: `newsCate/getIndexCate`,
    method: 'get',
    params
  })
}
